module.exports = __webpack_public_path__ + "static/c1e68c1992cd72ee41122d593059726ff5dc6c7eb7fbb46c6fbee33b15df7267-ef914df415bf130d794cb6b5346f22e5.jpeg";